import React from 'react'
import AppBarNanooxBolt from "./components/AppBarNanooxBolt";
import './Layout.css'

const Layout = ({
  children,
  servidor,
  translate,
  idioma,
  pendienteData,
  SWVersion,
  hora,
  barcos,
  selectedCentro,
  setSelectedCentro,
  cambioVista,
}) => {
  return (
    <div className="nanoox-layout-bolt">
      <header className="nanoox-appbar-bolt"> 
        <AppBarNanooxBolt
          servidor={servidor}
          hora={hora}
          cambioVista={cambioVista}
          translate={translate}
          idioma={idioma}
          version={SWVersion}
          pendienteData={pendienteData}
          barcos={barcos}
          selectedCentro={selectedCentro}
          setSelectedCentro={setSelectedCentro}
        />
      </header>
      <div className="nanoox-content-bolt">
        <main className="nanoox-main-bolt">
          {children}
        </main>
      </div>
    </div>
  )
}

export default Layout
